module.exports = __webpack_public_path__ + "static/img/84088F_2_3_R_20200713_LC.5eeb46c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84088F_2_3_R_20200713_LC.png
// module id = OyRj
// module chunks = 0